"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunk42GRYRWZjs = require('./chunk-42GRYRWZ.js');var _chunkPOE2IUJUjs = require('./chunk-POE2IUJU.js');var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _react = require('react'); var g = _interopRequireWildcard(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var C=_styled2.default.a`
  box-sizing: border-box;
  display: flex;
  text-decoration: none;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  position: relative;
  max-width: ${e=>e.theme.measurements.spacing(100)};
  height: 100%;
  padding: ${e=>e.theme.measurements.spacing(8)};
  gap: ${e=>e.theme.measurements.spacing(5)};
  background: ${e=>e.theme.palette.BASE_ONE};
  border: ${e=>e.theme.measurements.spacing(.5)} solid
    ${e=>e.theme.palette.DIVIDER};
  border-radius: ${e=>e.theme.measurements.spacing(4)};
  @media screen and (max-width: ${e=>e.theme.breakpoint.mobile}) {
    max-width: ${e=>e.theme.measurements.spacing(100)};
    flex-direction: column;
    gap: ${e=>e.theme.measurements.spacing(6)};
  }
`,L=_styled2.default.div`
  width: ${e=>e.theme.measurements.spacing(84)};
  height: ${e=>e.theme.measurements.spacing(85)};
  border-radius: ${e=>e.theme.measurements.spacing(4)};
  justify-content: center;
  position: relative;
  display: block;
  flex-shrink: 0;
`,T=_styled2.default.div`
  height: ${e=>e.theme.measurements.spacing(85)};
  overflow: hidden;
  border-radius: ${e=>e.theme.measurements.spacing(4)};
`,k=_styled2.default.div`
  position: absolute;
  width: ${e=>e.theme.measurements.spacing(59.66)};
  height: ${e=>e.theme.measurements.spacing(21.5)};
  right: 0px;
  bottom: 0px;
`,N=_styled2.default.div`
  display: flex;
  flex-direction: row;
  gap: ${e=>e.theme.measurements.spacing(4)};
  align-items: center;
`,I=_styled2.default.div`
  display: flex;
  flex-flow: column;
  flex:1;
  gap: ${e=>e.theme.measurements.spacing(3)};
`,R=_styled2.default.div`
  display: flex;
  flex-flow: column;
  gap: ${e=>e.theme.measurements.spacing(3)};
  flex: 1;
`,A=_styled2.default.call(void 0, _chunkPOE2IUJUjs.b)`
  font-size: ${e=>e.theme.measurements.spacing(5)};
  white-space: nowrap;
`,D=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  color: ${e=>e.$topicColor||e.theme.palette.VIOLET};
  font-size: ${e=>e.theme.measurements.spacing(5)};
  font-weight: 700;
  line-height: ${e=>e.theme.measurements.spacing(6)};
  text-transform: uppercase;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`,W=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
display: -webkit-box;
-webkit-line-clamp: 3;
-webkit-box-orient: vertical;  
overflow: hidden;
@media screen and (max-width: ${e=>e.theme.breakpoint.mobile}) {
  line-height: ${e=>e.theme.measurements.spacing(9)};
}
`,M=_styled2.default.div`
  font-size: ${e=>e.theme.measurements.spacing(6)};
  line-height: ${e=>e.theme.measurements.spacing(8)};
  font-weight: 400;
  color: ${e=>e.theme.palette.SECONDARY};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  a {
    color: ${e=>e.theme.palette.SECONDARY};
  }
`,z=g.forwardRef((e,f)=>{let{educatorName:i,langLabel:r,topicName:l,topicColor:y,title:$,onClick:m,thumbnail:c,href:w,target:b,className:x,as:E="a",educatorLink:p,lessons:d}=e,v=n=>{m&&m(n)},P=n=>{n.stopPropagation()};return _jsxruntime.jsxs.call(void 0, C,{ref:f,target:b||"_self",href:w,onClick:v,className:`${x||""} aquilla-educator-playlist-card educator-playlist-card`,as:E,children:[_jsxruntime.jsx.call(void 0, L,{className:"aquilla-educator-playlist-educator-thumbnail-wrapper",children:_jsxruntime.jsxs.call(void 0, T,{children:[typeof c=="function"&&_jsxruntime.jsx.call(void 0, c,{}),d&&_jsxruntime.jsx.call(void 0, k,{children:_jsxruntime.jsx.call(void 0, _chunk42GRYRWZjs.b,{lessons:d})})]})}),_jsxruntime.jsxs.call(void 0, I,{className:"aquilla-educator-playlist-details-wrapper",children:[_jsxruntime.jsxs.call(void 0, R,{className:"aquilla-educator-playlist-info",children:[_jsxruntime.jsxs.call(void 0, N,{children:[r&&_jsxruntime.jsx.call(void 0, A,{variant:"default",size:"small",children:r}),l&&_jsxruntime.jsx.call(void 0, D,{as:"div",variant:"h1",$topicColor:y,children:l})]}),_jsxruntime.jsx.call(void 0, W,{variant:"h6",children:$})]}),_jsxruntime.jsx.call(void 0, M,{children:p?_jsxruntime.jsx.call(void 0, "a",{href:p||"",title:i,onClick:P,children:i}):i})]})]})}),S= exports.a =z;exports.a = S;
